import React, { useState, useEffect } from 'react';
import { Form, Select, Input, Row, Col, Button, Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import FloatingLabel from '../../../../components/FloatingLabel/FloatingLabel';
import SuccessModal from '../../../../components/SuccessModal/SuccessModal';
import { CloseIcon, ChevronDown, ChevronUp } from '../../../../assets/icons';
import { ssnRegex } from '../../../../utils/Validations';
import { formatSSN } from '../../../../utils/formatSSN';
import { toastNotify } from '../../../../utils/toastNotify';
import { updateUserProfile } from '../../../../services/authApi/userApi';
import { changeIdentificationDetails, addCounter } from '../../../../store/reducer/accountSlice';
import { allowOnlyFourDigit, allowOnlyTwoDigit } from '../../../../utils/allowOnlyFourDigit';
import { check150YearValid } from '../../../../utils/checkYearValid';

const EditIdDetails = (props) => {
  const [citizenship, setCitizenship] = useState('uscitizen');
  const [month, setMonth] = useState();
  const [day, setDay] = useState();
  const [year, setYear] = useState();
  const [ssn, setSsn] = useState();
  const [successOpen, setSuccessOpen] = useState(false);
  const [form] = Form.useForm();
  const { userProfileData } = props;
  const [isEdit, setEdit] = useState(false);
  const [loading, setLoaing] = useState(false);
  const dispatch = useDispatch();
  const counter = useSelector((state) => state.userData.counter);
  const [arrowUp, setArrowUp] = useState(false);
  const [isChangedValue, setIsChangedValue] = useState(false);

  useEffect(() => {
    handleSetDefaultData();
  }, [userProfileData]);

  const handleSetDefaultData = () => {
    if (Object.keys(userProfileData)?.length > 0) {
      // const ssnFormate = `XXX-XX-X${ssn?.slice(8, 11)}`;
      const day = userProfileData?.dob?.slice(3, 5);
      const month = userProfileData?.dob?.slice(0, 2);
      const year = userProfileData?.dob?.slice(6, 10);
      form.setFieldsValue({
        ssn: userProfileData?.ssn,
        year: year,
        day: day,
        month: month,
      });
      setDay(day);
      setYear(year);
      setMonth(month);
      setSsn(ssn);
      setEdit(true);
    }
  };

  const handleInput = (e) => {
    const { value } = e.target;
    // this is where we'll call the formatSSN function
    const formattedSSN = formatSSN(value);
    // we'll set the input value using our setFieldsValue
    form.setFieldValue('ssn', formattedSSN);
    setSsn(formattedSSN);
  };

  const onIdDetailsSubmit = async (values) => {
    setLoaing(true);
    const dobInput = `${values.month}/${values.day}/${values.year}`;

    const formIdData = {
      ssn: values.ssn,
      dob: dobInput,
    };
    try {
      const resp = await updateUserProfile(formIdData);
      if (!resp.isError) {
        counter === 2 && dispatch(addCounter(3));
        dispatch(changeIdentificationDetails(formIdData));
        props.setClose();
        setSuccessOpen(true);
      } else {
        toastNotify('error', resp?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoaing(false);
    }
  };

  const closedSuccessModal = () => {
    setSuccessOpen(false);
  };

  const moveFocusToTheNextField = (valueLength, length, fieldName) => {
    if (valueLength === length) {
      const nextfield = document.querySelector(`input[name=${fieldName}]`);
      nextfield.focus();
    }
  };

  const handleSetMonth = (value) => {
    const monthInput = allowOnlyTwoDigit(value);
    form.setFieldValue('month', monthInput);
    setMonth(monthInput);
    moveFocusToTheNextField(value.length, 2, 'day');
  };

  const handleSetDay = (value) => {
    const dayInput = allowOnlyTwoDigit(value);
    form.setFieldValue('day', dayInput);
    setDay(dayInput);
    moveFocusToTheNextField(value.length, 2, 'year');
    // moveFocusToTheNextField(value.length, 0, 'month');
  };

  const handleSetYear = (value) => {
    const yearInput = allowOnlyFourDigit(value);
    form.setFieldValue('year', yearInput);
    setYear(yearInput);

    return `${month}/${day}/${yearInput}`;
    // moveFocusToTheNextField(value.length, 0, 'day');
  };

  const handleCheckChanges = (values) => {
    const day = userProfileData?.dob?.slice(3, 5);
    const month = userProfileData?.dob?.slice(0, 2);
    const year = userProfileData?.dob?.slice(6, 10);
    if (
      Number(day) !== Number(values?.day) ||
      Number(values?.month) !== Number(month) ||
      Number(values?.year) !== Number(year) ||
      userProfileData?.ssn !== values?.ssn
    ) {
      setIsChangedValue(true);
    } else {
      setIsChangedValue(false);
    }

  }
  return (
    <>
      <Modal
        className='account__modal'
        open={props.setOpen}
        onCancel={() => {
          props.setClose();
          handleSetDefaultData();
        }}
        width={524}
        footer={false}
        closeIcon={<CloseIcon />}
        centered
      >
        <h4 className='mb-32 account__modal__title'>Edit identification details</h4>
        <Form
          onFieldsChange={() => handleCheckChanges(form.getFieldValue())}
          form={form}
          name='editIdDetailsForm'
          onFinish={onIdDetailsSubmit}
          autoComplete='off'
        >
          <FloatingLabel label='Citizenship status' inputId='citizenship' inputValue={citizenship}>
            <>
              <div id='id-anchor' />
              <Form.Item className='mb-4'>
                <Select
                  id='citizenship'
                  onChange={(value) => setCitizenship(value)}
                  value={citizenship}
                  getPopupContainer={() => document.getElementById('id-anchor')}
                  onDropdownVisibleChange={() => setArrowUp(!arrowUp)}
                  suffixIcon={arrowUp ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
                  disabled
                >
                  <Select.Option value='uscitizen'>U.S. Citizen</Select.Option>
                  <Select.Option value='indian'>Indian Citizen</Select.Option>
                </Select>
              </Form.Item>
            </>
          </FloatingLabel>
          <p className='fz-12 mb-16'>
            If your citizenship status has changed, please{' '}
            <a className='underline text-almost-black' href='mailto:support@realbricks.com'>
              contact support
            </a>
            .
          </p>
          <p className='mb-8'>Date of birth</p>
          <Row gutter={[16, 0]}>
            <Col span={12} md={8} xl={6}>
              <FloatingLabel label='Month' inputId='month' isEdit={isEdit} inputValue={month}>
                <Form.Item
                  validateTrigger="onBlur"
                  name='month'
                  rules={[
                    {
                      required: true,
                      validator: (_, value) => check150YearValid(value, 'month', `${month}/${day}/${year}`),
                    },
                  ]}
                  dependencies={['day', 'year']}
                >
                  <Input
                    id='month'
                    value={month}
                    name='month'
                    onChange={(e) => handleSetMonth(e.target.value.replace(/[^0-9]/g, ''))}
                    maxLength={2}
                    placeholder='MM'
                  />
                </Form.Item>
              </FloatingLabel>
            </Col>
            <Col span={12} md={8} xl={6}>
              <FloatingLabel label='Day' inputId='day' isEdit={isEdit} inputValue={day}>
                <Form.Item
                  validateTrigger="onBlur"
                  name='day'
                  rules={[
                    {
                      required: true,
                      validator: (_, value) => check150YearValid(value, 'day', `${month}/${day}/${year}`),
                    },
                  ]}
                  dependencies={['month', 'year']}
                >
                  <Input
                    id='day'
                    value={day}
                    name='day'
                    onChange={(e) => handleSetDay(e.target.value.replace(/[^0-9]/g, ''))}
                    maxLength={2}
                    placeholder='DD'
                  />
                </Form.Item>
              </FloatingLabel>
            </Col>
            <Col span={24} md={8} xl={6}>
              <FloatingLabel label='Year' inputId='year' isEdit={isEdit} inputValue={year}>
                <Form.Item
                  validateTrigger="onBlur"
                  name='year'
                  rules={[
                    {
                      required: true,
                      validator: (_, value) => check150YearValid(handleSetYear(value.replace(/[^0-9]/g, '')), 'year', `${month}/${day}/${year}`),
                    },
                  ]}
                  dependencies={['day', 'month']}
                >
                  <Input
                    id='year'
                    value={year}
                    name='year'
                    onChange={(e) => handleSetYear(e.target.value.replace(/[^0-9]/g, ''))}
                    maxLength={4}
                    placeholder='YYYY'
                  />
                </Form.Item>
              </FloatingLabel>
            </Col>
          </Row>
          <FloatingLabel label='Social security number' inputId='ssn' inputValue={ssn} isEdit={isEdit}>
            <Form.Item
              validateTrigger="onBlur"
              className='mb-48'
              name='ssn'
              rules={[
                {
                  required: true,
                  pattern: new RegExp(ssnRegex),
                  message: 'Enter a valid SSN',
                },
              ]}
            >
              <Input
                id='ssm'
                value={ssn}
                placeholder='XXX-XX-XXXX'
                maxLength={11}
                onChange={(e) => handleInput(e)}
              />
            </Form.Item>
          </FloatingLabel>
          <Row gutter={[16, 16]}>
            <Col span={24} sm={12}>
              <Form.Item className='mb-0'>
                <Button
                  onClick={() => {
                    props.setClose();
                    handleSetDefaultData();
                  }}
                  className='w-100'
                >
                  Cancel
                </Button>
              </Form.Item>
            </Col>
            <Col span={24} sm={12}>
              <Form.Item className='mb-0' shouldUpdate>
                {() => (
                  <Button
                    className='w-100'
                    type='primary'
                    htmlType='submit'
                    loading={loading}
                    disabled={!!form.getFieldsError().filter(({ errors }) => errors.length).length || !isChangedValue}
                  >
                    Save
                  </Button>
                )}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <SuccessModal
        setOpen={successOpen}
        setClose={() => closedSuccessModal(false)}
        setDone={() => {
          closedSuccessModal(false);
        }}
      />
    </>
  );
};

export default EditIdDetails;
